module.exports = __webpack_public_path__ + "img/type4_check1.db9a2d74.png";